var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7733 0.853221C18.8441 0.25726 19.7089 0.25726 19.7797 0.853221L20.3729 5.85279C21.1389 12.3086 26.2288 17.3985 32.6845 18.1645L37.6841 18.7577C38.2801 18.8285 38.2801 19.6933 37.6841 19.764L32.6845 20.3573C26.2288 21.1233 21.1389 26.2132 20.3729 32.6689L19.7797 37.6685C19.7089 38.2645 18.8441 38.2645 18.7733 37.6685L18.1801 32.6689C17.4141 26.2132 12.3242 21.1233 5.86842 20.3573L0.868846 19.764C0.272885 19.6933 0.272885 18.8285 0.868846 18.7577L5.86842 18.1645C12.3242 17.3985 17.4141 12.3086 18.1801 5.85279L18.7733 0.853221Z",
    fill: "#7551FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartStar);
export default __webpack_public_path__ + "static/media/StartStar.0038cbd8281c49a2fd872e3eec92ca6e.svg";
export { ForwardRef as ReactComponent };